import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <Route
    key="/consumer/apps/ycp"
    element={
      <DefaultConsumerLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Consumer',
            item: '/consumer',
          },
          {
            position: 3,
            name: 'YCP',
            item: '/consumer/apps/ycp',
          },
        ]}
      />
    }
  >
    <Route path="consumer/apps/ycp" element={<AsyncPage />} />
  </Route>,
];
